import Api from '@/services/Api'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
 getPatients () {
   return Api().get("/patients");
},
  getPatientsByUser (params) {
    return Api().get("/patients-by-user/"+params);
  },
  updatePatient (params) {
    return Api().put("/patients",params);
  },
  addPatient (params) {
    return Api().post("/patients",params);
  },
  getPatient (params) {
    return Api().get("/patients/"+params);
  },
  deletePatient (params) {
    return Api().delete("/patients/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/PatientService.js